import { SlotMachine } from '../../features/games/slot-machine/SlotMachine';
import { useGameConfig } from './gamePageHelpers';
import { Spinner } from '../../components/Spinner';

export function SlotMachinePage() {
  const { isLoading, enabled, minBet, maxBet } = useGameConfig('slot');
  if (isLoading) return <Spinner full />;

  return (
    <div className="space-y-6">
      <h1 className="text-center text-3xl font-bold text-gold">🎰 Slot Machine</h1>
      {enabled ? (
        <SlotMachine minBet={minBet} maxBet={maxBet} />
      ) : (
        <p className="text-center text-slate-400">
          This game is currently unavailable.
        </p>
      )}
    </div>
  );
}
